export enum SequenceModelState {
	ACTIVE = 'ACTIVE',
	ARCHIVED = 'ARCHIVED'
}
